import "./Post.css";

function PostLoadingOverlay({ text = "Reporting post..." }) {
  return (
    <div className="post-loading-overlay">
      <div className="post-loading-spinner">
        <svg
          className="animate-spin"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          style={{ opacity: 1 }}
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            style={{ opacity: 0.25 }}
          />
          <path
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            style={{ opacity: 0.75 }}
          />
        </svg>
        <p>{text}</p>
      </div>
    </div>
  );
}

export default PostLoadingOverlay;
